module.exports = {
    "result": "success",
    "listDetails": "upload list test",
    "idList": "7102907",
    country: "CA",
    "addresses": [
        {
            "idPrimary": 1598610020,
            "idList": 7102907,
            "name": "test upload",
            "name2": "",
            "address": "1111 FOREST PARK BLVD",
            "address2": "",
            "city": "FORT WORTH",
            "state": "TX",
            "country": "US",
            "zip": "76110",
            "plus4": "1154",
            "deliveryPoint": "11",
            "checkDigit": "2",
            "status": "PASSED",
            "runtime": "2020-11-26T10:30:23-06:00",
            "failed": "0",
            "ncoaFailed": false,
            "doNotMail": false,
            "errorCode": "",
            "addressId": null,
            "crrt": null,
            "resultCode": "",
            "source": null,
            "sourceId": null,
            "sourceOwner": null
        }, {
            "idPrimary": 1598610021,
            "idList": 7102907,
            "name": "test upload",
            "name2": "",
            "address": "1115 FOREST PARK BLVD",
            "address2": "",
            "city": "FORT WORTH",
            "state": "TX",
            "country": "US",
            "zip": "76110",
            "plus4": "1154",
            "deliveryPoint": "15",
            "checkDigit": "8",
            "status": "PASSED",
            "runtime": "2020-11-26T10:30:23-06:00",
            "failed": "0",
            "ncoaFailed": false,
            "doNotMail": false,
            "errorCode": "",
            "addressId": null,
            "crrt": null,
            "resultCode": "",
            "source": null,
            "sourceId": null,
            "sourceOwner": null
        }, {
            "idPrimary": 1598610022,
            "idList": 7102907,
            "name": "test upload",
            "name2": "",
            "address": "2200 W ROSEDALE ST S APT B",
            "address2": "",
            "city": "FORT WORTH",
            "state": "TX",
            "country": "US",
            "zip": "76110",
            "plus4": "1170",
            "deliveryPoint": "74",
            "checkDigit": "5",
            "status": "PASSED",
            "runtime": "2020-11-26T10:30:23-06:00",
            "failed": "0",
            "ncoaFailed": false,
            "doNotMail": false,
            "errorCode": "",
            "addressId": null,
            "crrt": null,
            "resultCode": "",
            "source": null,
            "sourceId": null,
            "sourceOwner": null
        }, {
            "idPrimary": 1598610023,
            "idList": 7102907,
            "name": "test upload",
            "name2": "",
            "address": "2201 W ROSEDALE ST S",
            "address2": "",
            "city": "FORT WORTH",
            "state": "TX",
            "country": "US",
            "zip": "76110",
            "plus4": "1139",
            "deliveryPoint": "01",
            "checkDigit": "0",
            "status": "DO NOT MAIL",
            "runtime": "2020-11-26T10:30:23-06:00",
            "failed": "0",
            "ncoaFailed": false,
            "doNotMail": true,
            "errorCode": "",
            "addressId": null,
            "crrt": null,
            "resultCode": "",
            "source": null,
            "sourceId": null,
            "sourceOwner": null
        }, {
            "idPrimary": 1598610024,
            "idList": 7102907,
            "name": "test upload",
            "name2": "",
            "address": "2204 W ROSEDALE ST S",
            "address2": "",
            "city": "FORT WORTH",
            "state": "TX",
            "country": "US",
            "zip": "76110",
            "plus4": "1138",
            "deliveryPoint": "04",
            "checkDigit": "8",
            "status": "PASSED",
            "runtime": "2020-11-26T10:30:23-06:00",
            "failed": "0",
            "ncoaFailed": false,
            "doNotMail": false,
            "errorCode": "",
            "addressId": null,
            "crrt": null,
            "resultCode": "",
            "source": null,
            "sourceId": null,
            "sourceOwner": null
        }, {
            "idPrimary": 1598610025,
            "idList": 7102907,
            "name": "test upload",
            "name2": "",
            "address": "2205 W ROSEDALE ST S",
            "address2": "",
            "city": "FORT WORTH",
            "state": "TX",
            "country": "US",
            "zip": "76110",
            "plus4": "1139",
            "deliveryPoint": "05",
            "checkDigit": "6",
            "status": "DO NOT MAIL",
            "runtime": "2020-11-26T10:30:23-06:00",
            "failed": "0",
            "ncoaFailed": false,
            "doNotMail": true,
            "errorCode": "",
            "addressId": null,
            "crrt": null,
            "resultCode": "",
            "source": null,
            "sourceId": null,
            "sourceOwner": null
        }, {
            "idPrimary": 1598610026,
            "idList": 7102907,
            "name": "test upload",
            "name2": "",
            "address": "2208 W ROSEDALE ST S",
            "address2": "",
            "city": "FORT WORTH",
            "state": "TX",
            "country": "US",
            "zip": "76110",
            "plus4": "1138",
            "deliveryPoint": "08",
            "checkDigit": "4",
            "status": "DO NOT MAIL",
            "runtime": "2020-11-26T10:30:23-06:00",
            "failed": "0",
            "ncoaFailed": false,
            "doNotMail": true,
            "errorCode": "",
            "addressId": null,
            "crrt": null,
            "resultCode": "",
            "source": null,
            "sourceId": null,
            "sourceOwner": null
        }, {
            "idPrimary": 1598610027,
            "idList": 7102907,
            "name": "test upload",
            "name2": "",
            "address": "2209 W ROSEDALE ST S",
            "address2": "",
            "city": "FORT WORTH",
            "state": "TX",
            "country": "US",
            "zip": "76110",
            "plus4": "1139",
            "deliveryPoint": "09",
            "checkDigit": "2",
            "status": "DO NOT MAIL",
            "runtime": "2020-11-26T10:30:23-06:00",
            "failed": "0",
            "ncoaFailed": false,
            "doNotMail": true,
            "errorCode": "",
            "addressId": null,
            "crrt": null,
            "resultCode": "",
            "source": null,
            "sourceId": null,
            "sourceOwner": null
        }, {
            "idPrimary": 1598610028,
            "idList": 7102907,
            "name": "test upload",
            "name2": "",
            "address": "2215 W ROSEDALE ST S",
            "address2": "",
            "city": "FORT WORTH",
            "state": "TX",
            "country": "US",
            "zip": "76110",
            "plus4": "1139",
            "deliveryPoint": "15",
            "checkDigit": "5",
            "status": "PASSED",
            "runtime": "2020-11-26T10:30:23-06:00",
            "failed": "0",
            "ncoaFailed": false,
            "doNotMail": false,
            "errorCode": "",
            "addressId": null,
            "crrt": null,
            "resultCode": "",
            "source": null,
            "sourceId": null,
            "sourceOwner": null
        }, {
            "idPrimary": 1598610029,
            "idList": 7102907,
            "name": "test upload",
            "name2": "",
            "address": "2217 W ROSEDALE ST S",
            "address2": "",
            "city": "FORT WORTH",
            "state": "TX",
            "country": "US",
            "zip": "76110",
            "plus4": "1139",
            "deliveryPoint": "17",
            "checkDigit": "3",
            "status": "DO NOT MAIL",
            "runtime": "2020-11-26T10:30:23-06:00",
            "failed": "0",
            "ncoaFailed": false,
            "doNotMail": true,
            "errorCode": "",
            "addressId": null,
            "crrt": null,
            "resultCode": "",
            "source": null,
            "sourceId": null,
            "sourceOwner": null
        }, {
            "idPrimary": 1598610030,
            "idList": 7102907,
            "name": "test upload",
            "name2": "",
            "address": "2218 W ROSEDALE ST S",
            "address2": "",
            "city": "FORT WORTH",
            "state": "TX",
            "country": "US",
            "zip": "76110",
            "plus4": "1138",
            "deliveryPoint": "18",
            "checkDigit": "3",
            "status": "DO NOT MAIL",
            "runtime": "2020-11-26T10:30:23-06:00",
            "failed": "0",
            "ncoaFailed": false,
            "doNotMail": true,
            "errorCode": "",
            "addressId": null,
            "crrt": null,
            "resultCode": "",
            "source": null,
            "sourceId": null,
            "sourceOwner": null
        }, {
            "idPrimary": 1598610031,
            "idList": 7102907,
            "name": "test upload",
            "name2": "",
            "address": "2220 W ROSEDALE ST S",
            "address2": "",
            "city": "FORT WORTH",
            "state": "TX",
            "country": "US",
            "zip": "76110",
            "plus4": "1138",
            "deliveryPoint": "20",
            "checkDigit": "0",
            "status": "DO NOT MAIL",
            "runtime": "2020-11-26T10:30:23-06:00",
            "failed": "0",
            "ncoaFailed": false,
            "doNotMail": true,
            "errorCode": "",
            "addressId": null,
            "crrt": null,
            "resultCode": "",
            "source": null,
            "sourceId": null,
            "sourceOwner": null
        }, {
            "idPrimary": 1598610032,
            "idList": 7102907,
            "name": "test upload",
            "name2": "",
            "address": "2221 W ROSEDALE ST S",
            "address2": "",
            "city": "FORT WORTH",
            "state": "TX",
            "country": "US",
            "zip": "76110",
            "plus4": "1139",
            "deliveryPoint": "21",
            "checkDigit": "8",
            "status": "DO NOT MAIL",
            "runtime": "2020-11-26T10:30:23-06:00",
            "failed": "0",
            "ncoaFailed": false,
            "doNotMail": true,
            "errorCode": "",
            "addressId": null,
            "crrt": null,
            "resultCode": "",
            "source": null,
            "sourceId": null,
            "sourceOwner": null
        }, {
            "idPrimary": 1598610033,
            "idList": 7102907,
            "name": "test upload",
            "name2": "",
            "address": "2229 W ROSEDALE ST S",
            "address2": "",
            "city": "FORT WORTH",
            "state": "TX",
            "country": "US",
            "zip": "76110",
            "plus4": "1139",
            "deliveryPoint": "29",
            "checkDigit": "0",
            "status": "DO NOT MAIL",
            "runtime": "2020-11-26T10:30:23-06:00",
            "failed": "0",
            "ncoaFailed": false,
            "doNotMail": true,
            "errorCode": "",
            "addressId": null,
            "crrt": null,
            "resultCode": "",
            "source": null,
            "sourceId": null,
            "sourceOwner": null
        }, {
            "idPrimary": 1598610034,
            "idList": 7102907,
            "name": "test upload",
            "name2": "",
            "address": "2232 W ROSEDALE ST S",
            "address2": "",
            "city": "FORT WORTH",
            "state": "TX",
            "country": "US",
            "zip": "76110",
            "plus4": "1138",
            "deliveryPoint": "32",
            "checkDigit": "7",
            "status": "PASSED",
            "runtime": "2020-11-26T10:30:23-06:00",
            "failed": "0",
            "ncoaFailed": false,
            "doNotMail": false,
            "errorCode": "",
            "addressId": null,
            "crrt": null,
            "resultCode": "",
            "source": null,
            "sourceId": null,
            "sourceOwner": null
        }, {
            "idPrimary": 1598610035,
            "idList": 7102907,
            "name": "test upload",
            "name2": "",
            "address": "123 FOREST PARK BLVD",
            "address2": "146A",
            "city": "FORT WORTH",
            "state": "TX",
            "country": "US",
            "zip": "76110",
            "plus4": "",
            "deliveryPoint": "",
            "checkDigit": "",
            "status": "FAILED",
            "runtime": "2020-11-26T10:30:23-06:00",
            "failed": "1",
            "ncoaFailed": true,
            "doNotMail": false,
            "errorCode": "",
            "addressId": null,
            "crrt": null,
            "resultCode": "AE10",
            "source": null,
            "sourceId": null,
            "sourceOwner": null
        }]
};